module.exports = __webpack_public_path__ + "i18n/uk_6aee649e78167d6c96ce98deed0871e6.json";


//////////////////
// WEBPACK FOOTER
// ./app/assets/i18n/uk.json
// module id = ypKR
// module chunks = 154